<template>
  <div class="border">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline">
      <el-form-item label="申请单号">
        <el-input v-model="searchForm.applicationId" clearable placeholder="申请单号"/>
      </el-form-item>
      <el-form-item>
        <el-button style="color: white;background-color: #009688;" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-tabs type="card" :active-name="activeName">
      <el-tab-pane :label="strategyExecutionRecord.startTime" :name="strategyExecutionRecord.id" v-for="(strategyExecutionRecord,i) in strategyExecutionRecords" :key="i" :lazy="true">
        <el-card>
          <h3>策略执行结果</h3>
          <el-card>
            <el-row>
              <el-col :span="2">
                <div class="grid-content bg-purple">策略code</div>
              </el-col>
              <el-col :span="3">
                <div class="grid-content bg-purple-light">{{strategyExecutionRecord.strategyCode}}</div>
              </el-col>
              <el-col :span="2">
                <div class="grid-content bg-purple">开始时间</div>
              </el-col>
              <el-col :span="3">
                <div class="grid-content bg-purple-light">{{strategyExecutionRecord.startTime}}</div>
              </el-col>
              <el-col :span="2">
                <div class="grid-content bg-purple">结束时间</div>
              </el-col>
              <el-col :span="3">
                <div class="grid-content bg-purple-light">{{strategyExecutionRecord.endTime}}</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="2">
                <div class="grid-content bg-purple">执行结果</div>
              </el-col>
              <el-col :span="22">
                <div class="grid-content bg-purple-light" style="word-wrap:break-word;">{{strategyExecutionRecord.strategyResult}}</div>
              </el-col>
            </el-row>
            <el-row v-if="strategyExecutionRecord.errorMsg">
              <el-col :span="2">
                <div class="grid-content bg-purple">异常信息</div>
              </el-col>
              <el-col :span="22">
                <div class="grid-content bg-purple-light">{{strategyExecutionRecord.errorMsg}}</div>
              </el-col>
            </el-row>
          </el-card>
          <h3>策略节点执行记录</h3>
          <el-card>
            <el-table ref="strategyNodeExecutionRecordTable" :data="strategyExecutionRecord.strategyNodeExecutionRecords" border stripe >
              <el-table-column type="index" label="序号" width="50" header-align="center" align="center" />
              <el-table-column prop="nodeCode" label="节点code" header-align="center" align="center" min-width="50"/>
              <el-table-column prop="executionResult" label="执行结果" header-align="center" align="center" min-width="200"/>
              <el-table-column prop="graphicNodeId" label="图形id" header-align="center" align="center" min-width="50"/>
              <el-table-column prop="startTime" label="开始时间" header-align="center" align="center" min-width="50"/>
              <el-table-column prop="endTime" label="结束时间" header-align="center" align="center" min-width="50"/>
            </el-table>
          </el-card>
          <h3>策略节点组件执行记录</h3>
          <el-card>
            <el-table ref="strategyNodeExecutionRecordTable" :data="strategyExecutionRecord.strategyNodeItemExecutionRecords" border stripe>
              <el-table-column type="index" label="序号" width="50" header-align="center" align="center" />
              <el-table-column prop="nodeCode" label="节点code" header-align="center" align="center" min-width="50"/>
              <el-table-column prop="itemCode" label="组件code" header-align="center" align="center" min-width="50"/>
              <el-table-column prop="executionResult" label="执行结果" header-align="center" align="center" min-width="200"/>
              <el-table-column prop="itemType" label="组件类型" header-align="center" align="center" min-width="50" :formatter="formatItemType"/>
              <el-table-column prop="executionTime" label="执行时间" header-align="center" align="center" min-width="50"/>
            </el-table>
          </el-card>
          <h3>相关变量中心变量值</h3>
          <el-card>
            <el-table ref="strategyNodeExecutionRecordTable" :data="strategyExecutionRecord.bigDataVariableRecords" border stripe>
              <el-table-column type="index" label="序号" width="50" header-align="center" align="center" />
              <el-table-column prop="variableName" label="名称" header-align="center" align="center" min-width="90"/>
              <el-table-column prop="variableValue" label="值" header-align="center" align="center" min-width="90"/>
              <el-table-column prop="variableType" label="类型" header-align="center" align="center" min-width="110"/>
            </el-table>
          </el-card>
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data () {
    return {
      searchForm: {
        applicationId: null
      },
      strategyExecutionRecords: [],
      activeName: '',
      itemTypes: [
        {value: 1, label: '规则'},
        {value: 2, label: '决策表'},
        {value: 3, label: '评分卡'},
        {value: 4, label: '脚本'},
        {value: 5, label: '节点赋值'}
      ]
    }
  },
  created () {
    this.initBack()
  },
  methods: {
    async initBack () {
      let applicationId = this.$route.params.applicationId
      if (applicationId) {
        this.searchForm.applicationId = this.$route.params.applicationId
        this.search()
      }
    },
    async search () {
      try {
        const res = await this.$http.get(`/strategy/strategy-data-record/${this.searchForm.applicationId}`)
        if (res.code === '200') {
          this.strategyExecutionRecords = res.data
          this.$nextTick(function () {
            this.activeName = this.strategyExecutionRecords[0] ? this.strategyExecutionRecords[0].startTime : ''
          })
        } else {
          this.strategyExecutionRecords = []
          this.$message.error(res.message)
        }
      } catch (err) {
        console.error(err)
      }
    },
    formatItemType (row, column, cellValue, index) {
      let itemType = this.itemTypes.find(s => s.value === cellValue)
      if (itemType) {
        return itemType.label
      }
      return cellValue
    }
  },
  components: {
  }
}
</script>

<style lang="stylus">
  h3 {
    margin: 15px 0 5px 0;
    font-weight: 400;
    color: #606266;
  }
  .bg-purple {
    text-align: center;
    vertical-align: middle;
    border:1px solid #ebeef5;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
  }
  .bg-purple-light {
    text-align: left;
    border:1px solid #ebeef5;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
  }
  .grid-content {
    min-height: 40px;
    padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/dataOperation/strategy-data-record.vue